module.exports = __webpack_public_path__ + "img/Icon-Sort-by.4234c609.svg";